import util from '@bmp-vue/core/api/util'

const controller = 'Projeto'
export default Object.assign({}, util.GetCrud(controller, null), {
  GetCustomJSON: function (codigo, isIdProjeto) {
    return util.Axios.Get(`${controller}/GetCustomJSON/${codigo}?isIdProjeto=${isIdProjeto}`);
  },
  PutCustomJSON: function (id, dto) {
    return util.Axios.Put(controller + '/PutCustomJSON', id, dto)
  },
  GetImagensProjeto: () => {
    return [
      { text: 'Fundo', value: 'background', regras: { extensao: ['image/svg+xml'], tamanho: 1, dimensao: { largura: 1800, altura: 950 } } },
      { text: 'Logo', value: 'logo', regras: { extensao: ['image/png', 'image/svg+xml'], tamanho: 1, dimensao: { largura: 1000, altura: 1000 } } },
      { text: 'Logo cores invertidas', value: 'logoInverted', regras: { extensao: ['image/png', 'image/svg+xml'], tamanho: 2, dimensao: { largura: 1000, altura: 1000 } } },
      { text: 'Ícone guia navegador', value: 'favicon', regras: { extensao: ['image/png', 'image/svg+xml'], tamanho: 1, dimensao: { largura: 500, altura: 500 } } },
    ];
  },
  GetCoresProjeto: () => {
    return [
      { variavel: 'primary', nome: 'Cor primária', cor: '#111111', editavel: true },
      { variavel: 'secondary', nome: 'Cor secundária', cor: '#7C7C7C', editavel: true },
      { variavel: 'accent', nome: 'Cor destaque', cor: '#82B1FF', editavel: false },
      { variavel: 'error', nome: 'Cor erro', cor: '#FF5252', editavel: false },
      { variavel: 'info', nome: 'Cor informação', cor: '#2196F3', editavel: false },
      { variavel: 'success', nome: 'Cor sucesso', cor: '#4CAF50', editavel: false },
      { variavel: 'warning', nome: 'Cor aviso', cor: '#FFC107', editavel: false }
    ];
  }
})
